function copyViaTextArea(content: string): boolean {
  const textArea = document.createElement("textarea");
  textArea.value = content;

  // hack to still copy to clipboard even if no permissions
  textArea.style.position = "absolute";
  textArea.style.left = "-999999px";

  // Beside the focused element rather than on <body>: a dialog's focus trap
  // takes focus back from anything outside it, and the selection with it.
  const focused =
    document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;
  (focused?.parentElement ?? document.body).append(textArea);
  textArea.select();

  try {
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    textArea.remove();
    focused?.focus();
  }
}

/** Returns whether the content actually reached the clipboard. */
export async function copyToClipboardWrapper(
  content: string
): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(content);
      return true;
    } catch {
      // NotAllowedError ("Document is not focused") when the window loses
      // focus between the click and the write — the execCommand path below
      // doesn't need async clipboard permission, so fall through to it.
    }
  }
  return copyViaTextArea(content);
}
